var map = {
	"./Features-Block-Navigate-DA-DK-D.avif": 92007,
	"./Features-Block-Navigate-DE-DE-D.avif": 29509,
	"./Features-Block-Navigate-EN-GB-D.avif": 84895,
	"./Features-Block-Navigate-EN-US-D.avif": 42774,
	"./Features-Block-Navigate-ES-ES-D.avif": 86175,
	"./Features-Block-Navigate-ES-MX-D.avif": 13454,
	"./Features-Block-Navigate-FR-FR-D.avif": 80767,
	"./Features-Block-Navigate-IT-IT-D.avif": 23293,
	"./Features-Block-Navigate-NB-NO-D.avif": 53156,
	"./Features-Block-Navigate-NL-NL-D.avif": 88227,
	"./Features-Block-Navigate-PL-PL-D.avif": 56107,
	"./Features-Block-Navigate-PT-BR-D.avif": 36351,
	"./Features-Block-Navigate-PT-PT-D.avif": 34987,
	"./Features-Block-Navigate-SV-SE-D.avif": 72232
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32944;